import { eWorkOrderState } from '../enums/eWorkOrderState'

export const workOrderOverdueStates = [
  eWorkOrderState.CREATED,
  eWorkOrderState.AVAILABLE_FOR_PICKING,
  eWorkOrderState.ON_PICKING_ROUTE,
  eWorkOrderState.ON_MASSIVE_PROCESS,
  eWorkOrderState.PICKING_FINISHED,
  eWorkOrderState.ON_VALIDATION,
  eWorkOrderState.VALIDATION_FINISHED,
  eWorkOrderState.AVAILABLE_FOR_EXTERNAL_PICKING
]

export const workOrderForTodayStates = [
  eWorkOrderState.CREATED,
  eWorkOrderState.AVAILABLE_FOR_PICKING,
  eWorkOrderState.ON_PICKING_ROUTE,
  eWorkOrderState.ON_MASSIVE_PROCESS,
  eWorkOrderState.PICKING_FINISHED,
  eWorkOrderState.ON_VALIDATION,
  eWorkOrderState.VALIDATION_FINISHED,
  eWorkOrderState.AVAILABLE_FOR_EXTERNAL_PICKING
]
